import React, { Component } from "react";
import { FaRegBookmark } from "react-icons/fa";
import axios from "axios";
// import { PiCurrencyNgn } from "react-icons/pi";
// import NumberDisplay from "./currencyValue";

class RelatedVideo extends Component {
    state = {
        courses: [],
    }

    componentDidMount() {
        this.fetchCourses();
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
    };


    relatedcourse = () => {
        const { courses } = this.state;

        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        const CurrentCourse = courses.filter((item) => item.id === courseId);
        const RemoveCurrentCourse = courses.filter((item) => item.id !== courseId);

        const currentCourseLabels = CurrentCourse.length > 0 ? CurrentCourse[0].labels : null; // Handle potential empty array

        const filteredCourses = RemoveCurrentCourse.filter((item) => {
            if (currentCourseLabels === null) {
                return false; // Or handle as you see fit when no current course is found.
            }
            return item.labels === currentCourseLabels;
        })
        return filteredCourses.slice(0, 4);
    };


    handleRedirect = (value) =>{
        const accessToken = localStorage.getItem("accessToken");
        if(accessToken){
            window.location = `/tutor_description/${value}`
        }else{
            window.location = `/Landing_description/${value}`
        }
    }

    render() {
        const relatedvideo = this.relatedcourse()
        const Related_course = relatedvideo.length ? relatedvideo.map((course) => {
            return (
                // <Link to={"/tutor_description/" + course.id} key={course.id}>
                    <div className="course_cover" onClick={() => this.handleRedirect(course.id)}>
                        <div className="image">
                            <img src={course.thumbnail} alt={"course" + course.id} />
                        </div>
                        <div className="about">
                            <h4>
                                <span>{course.labels}</span><br />
                                {course.title}
                            </h4>
                            {/* <p><PiCurrencyNgn /><NumberDisplay value ={course.price}/> </p> */}
                            <button className="edit"><FaRegBookmark /></button>
                        </div>

                    </div>
                // </Link>
            )
        }) : (<li>no related course</li>)


        return (
            <section className="related_video">
                <h3>Related Courses</h3>
                {Related_course}
                {/* <div className="course_cover">
                    
                    <div className="image">

                    </div>
                    <div className="about">
                        <h4>
                            <span>GIS</span><br />
                            Unit Testing in Python
                        </h4>
                        <p>#30,000</p><button><FaRegBookmark /></button>
                    </div>

                </div>
                <div className="course_cover">
                    <div className="image">

                    </div>
                    <div className="about">
                        <h4>
                            <span>GIS</span><br />
                            Unit Testing in Python
                        </h4>
                        <p>#30,000</p><button><FaRegBookmark /></button>
                    </div>

                </div>
                <div className="course_cover">
                    <div className="image">

                    </div>
                    <div className="about">
                        <h4>
                            <span>GIS</span><br />
                            Unit Testing in Python
                        </h4>
                        <p>#30,000</p><button><FaRegBookmark /></button>
                    </div>

                </div> */}

            </section>

        )
    }
}

export default RelatedVideo